<template>
  <v-container fluid class="breadcrumbs-wrapper pb-0">
    <v-row>
      <v-col>
        <v-card class="app-card" text>
          <v-card-text class="py-0 px-0 my-0 mx-0">
            <breadcrumbs />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Breadcrumb',
}
</script>

<style lang="scss">
  @import "../../assets/scss/app.variables";

  .gg-breadcrumbs {
    a {
      color: $hoz-nav-link-color !important;
      font-size: 0.875rem;
    }
  }

  .v-breadcrumbs__divider {
    padding: 0 6px !important;
  }
</style>
